import React, { Component, Fragment } from 'react';
import { connect } from 'dva';

import { NavBar } from 'antd-mobile';
import router from 'umi/router';
import './index.less';
import { getValue, getUrlParam, getShowTopBar } from 'utils/getValue';
import iconBack from 'images/icon_back.png';
class NavHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
    };
  }

  showDialog() {
    try {
      const { isShow } = this.state;
      this.setState({ isShow: !isShow });
    } catch (error) {
      console.log('显示拨打电话--', error);
    }
  }

  hideDialog() {
    this.setState({ isShow: false });
  }

  backHome() {
    router.push({
      pathname: '/home',
      query: JSON.parse(localStorage.getItem('urlParams')),
    });
  }

  render() {
    let { showHome = true, hideBack = false, showCallBox: showCall = true } = this.props;
    // 兼容以前login接口也存一次，导致undefined
    const showTopBar = getShowTopBar();
    const { isShow } = this.state;
    const { backUrl } = this.props;
    const title = this.props.title;
    const lg = localStorage.getItem('language') || 'zh-cn';
    const channel = getValue('channel');
    const urlShowBack = getUrlParam('showBack') || ''; // 0  不展示  1展示
    const urlShowHome = getValue('showHome') || '1'; // 0  不展示  1展示
    const urlShowCall =
      getValue('showCall', {
        storageType: 'session',
      }) || '1'; // 0 不展示  1展示
    let showCallBox = channel !== 'gnsyd' && showCall;
    if (urlShowCall === '0') showCallBox = false;
    showHome = showHome && urlShowHome !== '0';
    // 如果没有参数，不能返回首页，不然返回也是空白的,这个参数在首页那有做缓存
    if (showHome) {
      const storageParams = localStorage.getItem('urlParams');
      const params = storageParams ? JSON.parse(storageParams) : {};
      const dragoncode = params.dragoncode || getValue('dragoncode');
      const qrcode = params.qrcode || getValue('qrcode');
      if (!dragoncode || !qrcode) {
        showHome = false;
      }
    }
    hideBack = urlShowBack === '0' || hideBack;
    const languageMap = {
      'zh-cn': {
        ServiceHotline: '客服热线',
        Jn: '境内普通话',
        Jw: '境外普通话',
        En: '英文',
        Cancel: '取消',
      },
      en: {
        ServiceHotline: 'Service Hotline',
        Jn: 'Call from Mainland China',
        Jw: 'Call from Overseas',
        En: 'English Service',
        Cancel: 'Cancel',
      },
    };
    // 北京私行得特殊处理
    if (channel === 'bjsh') {
      showHome = false;
    }
    const isHaierChannel = channel === 'haier';
    return (
      showTopBar && (
        <Fragment>
          <NavBar
            mode="light"
            style={{ zIndex: 2999 }}
            icon={hideBack ? null : <img key="0" className="back-icon" src={iconBack} alt="" />}
            onLeftClick={() => {
              if (hideBack) {
                return;
              }
              if (backUrl && backUrl !== '') {
                if (typeof backUrl === 'function') {
                  backUrl();
                } else {
                  window.location.href = backUrl;
                }
                return;
              }
              window.history.go(-1);
            }}
            rightContent={[
              <Fragment key="1">
                {showCallBox && (
                  <div key="1" onClick={() => this.showDialog()}>
                    <img className="phone-icon" src={require('images/icon_phone.png')} alt="" />
                  </div>
                )}
                {showHome ? (
                  <div key="2" onClick={() => this.backHome()} style={{ marginLeft: '16px' }}>
                    <img className="phone-icon" src={require('images/icon_home.png')} alt="" />
                  </div>
                ) : null}
              </Fragment>,
            ]}
          >
            {title}
          </NavBar>

          {isShow && (
            <div className="hotline-wrap">
              <div className="hotline">
                <div className="title">
                  {languageMap[lg].ServiceHotline}
                  <span className="cancel" onClick={() => this.hideDialog()}>
                    {languageMap[lg].Cancel}
                  </span>
                </div>
                <div className="content">
                  {!isHaierChannel ? (
                    <>
                      <a href="tel:400-882-1111">400-882-1111（{languageMap[lg].Jn}）</a>
                      <a href="tel:+86(513)8719-9488">+86(513)8719-9488（{languageMap[lg].Jw}）</a>
                      <a href="tel:+448081966002">+448081966002（{languageMap[lg].En}）</a>
                    </>
                  ) : (
                    <a href="tel:400-813-1888">400-813-1888（{languageMap[lg].Jn}）</a>
                  )}
                </div>
              </div>
            </div>
          )}
        </Fragment>
      )
    );
  }
}

export default NavHeader;
